import { Component } from 'react';
import { ContentPlaceholder } from './ContentPlaceholder';

interface IProps {
  numItems?: number;
  itemHeight?: number;
}

export class PlaceholderList extends Component<IProps> {
  public render() {
    const gap = 20;
    const numItems = this.props.numItems || 3;
    const itemHeight = this.props.itemHeight || 70;
    const height = `${(itemHeight + gap) * numItems}px`;
    return (
      <ContentPlaceholder height={height}>
        {[...Array(numItems)].map((_, i) => (
          <rect key={i} x="0" y={i * (itemHeight + gap)} rx="0" ry="0" width={'100%'} height={itemHeight + 'px'} />
        ))}
      </ContentPlaceholder>
    );
  }
}
